import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificacionesDataService } from 'src/app/modules/notificaciones/services/notificaciones-data.service';
import { DialogUtilsService } from 'src/app/shared/util/dialog-utils/dialog-utils.service';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../core/auth/account.service';
import { Account } from '../../core/user/account.model';
import { PersonalizarComponent } from './personalizar/personalizar.component';

@Component({
  selector: 'tel-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map((result) => result.matches));

  account: Account | null = null;
  authSubscription?: Subscription;
  langSubscription?: Subscription;
  subscripcionNotificaciones: Subscription;
  numNotificacionesPorLeer: number = 0;
  idiomaActual: string = 'ca';

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private translate: TranslateService,
    private accountService: AccountService,
    private sanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private matDialog: MatDialog,
    private notificacionesDataService: NotificacionesDataService,
    private dialogUtilsService: DialogUtilsService
  ) {
    this.matIconRegistry.addSvgIcon('gva', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/logo_gva_fff.svg'));
  }

  ngOnInit() {
    this.suscribirseIndicadorNotificacionesPorLeer();

    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.idiomaActual = this.translate.currentLang;
    });

    this.authSubscription = this.accountService.getAuthenticationState().subscribe((account) => {
      this.account = account;
      if (this.isIdentified()) {
        this.notificacionesDataService.actualizarNotificacionesPorLeer();
      }
    });
  }

  private suscribirseIndicadorNotificacionesPorLeer() {
    this.subscripcionNotificaciones = this.notificacionesDataService.numeroNotificacionesPorLeerObservable.subscribe((numeroPorLeer: number) => {
      this.numNotificacionesPorLeer = numeroPorLeer;
    });
  }

  changeLanguage(langKey: string) {
    this.translate.use(langKey);
    this.router.navigate(['/convocatorias']);
  }

  isCurrentLanguage(langKey: string) {
    return this.translate.currentLang === langKey;
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  isIdentified(): boolean {
    return !this.accountService.isAnonymous();
  }

  logout(): void {
    this.dialogUtilsService.abrirLogout({
      success: () => {
        this.router.navigate(['/logout']);
      },
    });
  }

  getLoggedUsername(): string {
    return this.account.firstName + ' ' + this.account.firstSurname;
  }

  abrirPersonalizar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = ['new_style', 'big_modal'];
    this.matDialog.open(PersonalizarComponent, dialogConfig);
  }

  abrirAyudaDocumento() {
    if (this.translate.currentLang === 'ca') {
      window.open(environment.urlAyudaPriuni.ca, '_blank');
    } else {
      window.open(environment.urlAyudaPriuni.es, '_blank');
    }
  }

  // abrirAyudaCreacionSolicitud() {
  //   if (this.translate.currentLang == 'ca') {
  //     window.open('#', '_blank');
  //   } else {
  //     window.open('#', '_blank');
  //   }
  // }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
    if (this.subscripcionNotificaciones) {
      this.subscripcionNotificaciones.unsubscribe();
    }
  }
}
